export enum FederatedModules {
  TMS = 'Loads',
  CREDIT = 'Credit',
  FUEL = 'Fuel',
  FREIGHT = 'Freight',
  FACTORING = 'Factoring',
  BANKING = 'Banking',
  LOAD_MANAGEMENT = 'Load Management',
}

export const ProductRequests = {
  Credit: 'CREDIT',
  Fuel: 'FUEL',
  Factoring: 'FACTORING',
  'Load Management': 'LOAD_MANAGEMENT',
  ProTransport: 'LOAD_MANAGEMENT',
} as const;
